import type { IconComponent } from "@overmap-ai/blocks"
import { ChevronDown, ChevronsUpDown, ChevronUp, Columns3Cog, EyeOff, ListFilter, X } from "lucide-react"

export const tableIconMapping = {
	descSort: ChevronDown,
	ascSort: ChevronUp,
	unsorted: ChevronsUpDown,
	clear: X,
	hide: EyeOff,
	filter: ListFilter,
	columns: Columns3Cog,
} satisfies Record<string, IconComponent>
